export const sharedAuthConstants = {
  authToken: {
    clienteId: 'api',
    clientSecret: 'api',
    grantType: 'client_credentials',
  },
  url: {
    login: '/page/login',
    autoLogin: '/page/login/auto/',
    signUp: '/crear-cuenta',
    verifyCodeUp: '/auto-verificacion/crear-cuenta',
    signUpVerify: '/crear-cuenta/verificacion',
    signUpData: '/crear-cuenta/datos',
    signUpPerson: '/crear-cuenta/facturacion/persona',
    signUpCompany: '/crear-cuenta/facturacion/empresa',
    recover: '/page/recover',
  },
  contactLink: {
    1: 'contactocolombia@mensajerosurbanos.com',
    3: 'contactomexico@mensajerosurbanos.com',
  },
};
